
import { PagedDialog } from '@components';
import { ShipperIcon } from '@img/icons';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import styles from './ReorderShipment.module.scss';

export const Menu = () => {
	return (
		<PagedDialog.Menu>
			<PagedDialog.MenuItem id={0} label={<p className={styles.subItem}><RefreshOutlinedIcon style={{ fontSize: '18px' }} />Quick Reorder</p>}>
				<PagedDialog.MenuItem
					id={0}
					label={
						<p className={styles.subItem}>
							<ManageSearchOutlinedIcon style={{ fontSize: '18px' }} />
							Reference Number
						</p>
					}
					subItem
				/>
				<PagedDialog.MenuItem
					id={1}
					label={
						<p className={styles.subItem}>
							<ShipperIcon width={16} height={16} />
							Cargo Details
						</p>
					}
					subItem
				/>
				<PagedDialog.MenuItem
					id={2}
					label={
						<p className={styles.subItem}>
							<NorthEastIcon style={{ fontSize: '18px' }} />
							Pick-Up
						</p>
					}
					subItem
				/>
				<PagedDialog.MenuItem
					id={3}
					label={
						<p className={styles.subItem}>
							<SouthEastIcon style={{ fontSize: '18px' }} />
							Drop-Off
						</p>
					}
					subItem
				/>
			</PagedDialog.MenuItem>
		</PagedDialog.Menu>
	);
}
Menu.displayName = 'Menu';
